import React, { lazy } from 'react';
import { TitlebarConfig, MenuConfig } from '@tencent/workbench';
import { TitleBarKey } from '@framework/workbench/schema/title-bar';
import { MenuKey } from '@framework/workbench/schema/menu-schema/common';
import LazyBoundary from '@com/LazyBoundary';
import PlayAction from  '@framework/workbench/ui/titlebar/components/play-action';
import { TitlebarKey } from '@tencent/docs-titlebar-service';
import { getToggleStatusByType, ToggleType } from '@src/slide/infrastructure/module/dependent/config/toggle-config';
import { isSyncManagerEnabled } from '@src/slide/domain/slide-app/scenes/offline/utils';


const MeetingRemotePlayButton = lazy(() => import(/* webpackChunkName: "tencent-meeting" */ '@tencent/docs-scenario-components-meeting-remote-play-button'));
const ConvertToOnlineButton = lazy(() => import(/* webpackChunkName: "convert-to-online-button" */ './components/convert-to-online-button'));
const LocalToSyncDocButton = lazy(() => import(/* webpackChunkName: "local-to-sync-doc-button" */ './components/local-to-sync-doc-button'));

export const MENU_CONFIGS: MenuConfig[] = [
    { name: MenuKey.FILE, content: '' },
];

// 是否使用本地的新版本【转多人在线】替换 titlebar 的【转多人在线】
const localFileTransfer = isSyncManagerEnabled()
    ? [{
        name: TitlebarKey.LOCAL_FILE_TRANSFER,
        content: <LazyBoundary>
            <ConvertToOnlineButton></ConvertToOnlineButton>
        </LazyBoundary>,
        preventHide: true,
        style: {
            marginLeft: 4,
        },
    }]
    : [];
const localToSyncDoc = getToggleStatusByType(ToggleType.NEW_LOCAL_TO_SYNC_DOC)
    ? [{
        // 临时套用TitlebarKey.LOCAL_FILE_UPLOAD车牌，灰度放开需要改
        name: TitlebarKey.LOCAL_FILE_UPLOAD,
        content: <LazyBoundary>
            <LocalToSyncDocButton></LocalToSyncDocButton>
        </LazyBoundary>,
    }]
    : [];

export const TITLEBAR_ITEMS: TitlebarConfig[] = [
    {
        name: TitleBarKey.PRESENTATION,
        content: <LazyBoundary>
            <PlayAction />
        </LazyBoundary>,
        preventHide: true,
        style: {
            fontSize: 0,
        },
    },
    ...localFileTransfer,
    ...localToSyncDoc,
    {
        name: TitlebarKey.TENCENT_MEETING,
        content: <div>
            <LazyBoundary>
                <MeetingRemotePlayButton
                    customStyle={{
                        cursor: 'default',
                        width: 28,
                        height: 28,
                        padding: 0,
                    }}
                    padType={window.clientVars?.padType}
                />
            </LazyBoundary>
        </div>,
        preventHide: true,
    },
];
